import { isDefined } from '@aloft/toolkit-shared';

import { TextFieldNodeAttributes } from './utils.ts';

export const createTextFieldNode = (
  doc: XMLDocument,
  attributes: TextFieldNodeAttributes,
  childNode?: Element,
) => {
  const node = doc.createElement('TextField');
  node.setAttribute('Id', attributes.Id);
  if (attributes.Data) node.setAttribute('Data', attributes.Data);

  if (isDefined(attributes.additional)) {
    for (const [key, val] of Object.entries(attributes.additional)) {
      if (isDefined(val)) node.setAttribute(key, val);
    }
  }

  if (childNode) node.appendChild(childNode);
  return node;
};
